var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home" }, [
    _c(
      "div",
      { staticClass: "home-inner" },
      [
        _c("h1", { staticClass: "home-logo" }, [
          _vm._v("\n      搜狗视频\n    "),
        ]),
        _vm._v(" "),
        _c("SearchBar"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }